import { useDispatch } from 'react-redux'

import { AppState } from 'store/types'
import { Action } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

export type AppDispatch = ThunkDispatch<AppState, any, Action>

export const useThunkDispatch = (): AppDispatch => useDispatch<AppDispatch>()

export default useThunkDispatch
